import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { api, currentYM } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { PageLoader } from "@/components/PageLoader";
import { ArrowLeft } from "lucide-react";
import { PerformanceView } from "@/components/PerformanceView";

export default function AdminPerformanceDetail() {
  const nav = useNavigate();
  const { userId } = useParams();
  const [sp] = useSearchParams();
  const [period, setPeriod] = useState(sp.get("period") || currentYM());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [animatedScore, setAnimatedScore] = useState(0);

  useEffect(() => {
    let cancel = false;
    setLoading(true);
    api.get(`/admin/performance/${userId}`, { params: { period } })
      .then((r) => { if (!cancel) setData(r.data); })
      .catch(() => { if (!cancel) setData(null); })
      .finally(() => { if (!cancel) setLoading(false); });
    return () => { cancel = true; };
  }, [period, userId]);

  useEffect(() => {
    if (!data) return;
    const target = data.score.value;
    let cur = 0;
    const step = target / 30;
    const iv = setInterval(() => {
      cur += step;
      if (cur >= target) { cur = target; clearInterval(iv); }
      setAnimatedScore(cur);
    }, 30);
    return () => clearInterval(iv);
  }, [data]);

  if (loading && !data) return <PageLoader label="Menghitung performa..." />;
  if (!data) return (
    <div className="p-6 max-w-xl mx-auto">
      <Button variant="ghost" size="sm" onClick={() => nav("/admin/performa")} data-testid="btn-back-list">
        <ArrowLeft className="w-4 h-4 mr-1" /> Kembali
      </Button>
      <p className="mt-4 text-sm text-zinc-500">Data pegawai tidak ditemukan.</p>
    </div>
  );

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-6 pb-12 max-w-2xl mx-auto" data-testid="admin-performance-detail-page">
      <div className="flex items-center gap-2 mb-4">
        <Button variant="ghost" size="icon" onClick={() => nav("/admin/performa")} className="h-8 w-8" data-testid="btn-back-list">
          <ArrowLeft className="w-4 h-4" />
        </Button>
        <div className="flex-1 min-w-0">
          <p className="overline">Performa Pegawai</p>
          <h1 className="font-display text-xl sm:text-2xl font-bold tracking-tight truncate">{data.user_name}</h1>
          <div className="flex gap-2 mt-1">
            <Badge variant="outline" className="text-[0.6rem]">
              {data.pay_type === "hourly" ? "PHL" : "Bulanan"}
            </Badge>
          </div>
        </div>
        <Input type="month" value={period} onChange={(e) => setPeriod(e.target.value)} className="w-32 text-xs" data-testid="perf-period" />
      </div>

      <PerformanceView data={data} animatedScore={animatedScore} />
    </div>
  );
}
